export enum EPaymentStatus {
  UnPaid = 'unpaid',
  Paid = 'paid',
  Deposited = 'deposited',
  PartialPaid = 'partial_paid',
  UnKnow = ''
}
export const EPaymentStatusColor: any = {
  [EPaymentStatus.Paid]: 'green',
  [EPaymentStatus.UnPaid]: 'yellow'
}
